import { Controller } from "stimulus"

// #1927: het facturatieoverzicht bij "Membership toevoegen". Haalt bij elke
// wijziging van type, startdatum of prijs het overzicht op van de server
// (SporterMembershipsController#facturatie_overzicht), die het berekent met
// dezelfde code als het echte koppelen. Er wordt niets opgeslagen.
//
// <form data-controller="facturatie-overzicht" data-facturatie-overzicht-url-value="..."
//       data-action="change->facturatie-overzicht#laden input->facturatie-overzicht#laden">
//   <div data-facturatie-overzicht-target="uitvoer"></div>
export default class extends Controller {
  static targets = ["uitvoer"]
  static values = { url: String }

  connect() {
    this.laden()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  laden() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.ophalen(), 250)
  }

  async ophalen() {
    if (!this.hasUitvoerTarget || !this.urlValue) return

    const params = new URLSearchParams()
    for (const [naam, waarde] of new FormData(this.element).entries()) {
      if (naam.startsWith("membership[")) params.append(naam, waarde)
    }
    this.volgnummer = (this.volgnummer || 0) + 1
    const volgnummer = this.volgnummer
    try {
      const antwoord = await fetch(`${this.urlValue}?${params.toString()}`, {
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin"
      })
      // Alleen het antwoord op de laatste wijziging telt
      if (volgnummer !== this.volgnummer || !antwoord.ok) return
      this.uitvoerTarget.innerHTML = antwoord.status === 204 ? "" : await antwoord.text()
    } catch (_fout) {
      // Geen overzicht is geen ramp: het koppelen werkt gewoon.
    }
  }
}
